export const SAKTI_UI_SIZE = {
  pagePadding: { base: 3, md: 4, xl: 6 },
  sectionGap: 4,
  pageTitle: { base: '2xl', md: '4xl' },
  pageSubtitle: 'sm',
  filterLabel: 'xs',
  filterGridGap: 2,
  controlHeight: '36px',
  cardRadius: 'xl',
  cardPadding: 4,
  kpiLabel: 'xs',
  kpiValue: { base: '3xl', md: '4xl' },
  kpiIconBoxSize: 8,
  chartTitle: { base: '2xl', md: '3xl' },
  chartSubtitle: 'sm',
  chartHeight: { base: '240px', md: '300px' },
  tabTitle: { base: 'xl', md: '2xl' },
  tableHeaderFont: 'xs',
  tableCellFont: 'sm',
  modalHeaderFont: 'lg',
} as const;

